module.exports = __webpack_public_path__ + "assets/138853399d908b8c7cbee3424ff4d57a.png";